var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "verify-tree-grid" } },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { attrs: { slot: "operations" }, slot: "operations" }, [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticStyle: {
                    "margin-right": "10px",
                    "padding-top": "10px"
                  },
                  attrs: { "label-width": "100px", "label-position": "left" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.FileNo"),
                                prop: "fileNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "1" },
                                model: {
                                  value: _vm.query.fileNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "fileNo", $$v)
                                  },
                                  expression: "query.fileNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.BusinessNo"),
                                prop: "jobNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "2" },
                                model: {
                                  value: _vm.query.jobNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "jobNo", $$v)
                                  },
                                  expression: "query.jobNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-bottom": "5px",
                                "margin-right": "10px",
                                display: "flex"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { "min-width": "100px" },
                                  attrs: { no: "3" },
                                  on: { change: _vm.setQuerySelectValue },
                                  model: {
                                    value: _vm.query.timeType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.query, "timeType", $$v)
                                    },
                                    expression: "query.timeType"
                                  }
                                },
                                _vm._l(_vm.timeTypes, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "4",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.query.timeStart,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "timeStart", $$v)
                                  },
                                  expression: "query.timeStart"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "padding-top": "5px" } },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_To")))]
                              ),
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "5",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.query.timeEnd,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "timeEnd", $$v)
                                  },
                                  expression: "query.timeEnd"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.CustomsBroker"),
                                prop: "customsBroker"
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  no: "6",
                                  placeholder: " ",
                                  "method-params": { customsBroker: true },
                                  "default-value": _vm.query.customsBroker || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.customsBroker = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: this.$t("SeaExport.Hbl2"),
                                prop: "jobHbl"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "7" },
                                model: {
                                  value: _vm.query.jobHbl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "jobHbl", $$v)
                                  },
                                  expression: "query.jobHbl"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: this.$t("SeaExport.PortOfLoadingAI"),
                                prop: "loadingPortCode"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                ref: "pod",
                                attrs: {
                                  no: "8",
                                  "select-type":
                                    _vm.query.portType === "AE"
                                      ? _vm.selectTypeNames.basic_data_Airport
                                      : _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  placeholder: " ",
                                  "default-value": _vm.query.loadingPortCode,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.query.loadingPortCode = p.code
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.FileType"),
                                prop: "fileTypes"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "9",
                                  filterable: "",
                                  multiple: true,
                                  placeholder: " ",
                                  "data-filter-function": _vm.dataFilterFunc,
                                  "callback-method-type": "value",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_TransmitFileType,
                                  "default-multiple-value": _vm.query.fileTypes,
                                  "tag-value": "name"
                                },
                                on: {
                                  parentCallBack: function(value) {
                                    return (_vm.query.fileTypes = [].concat(
                                      value
                                    ))
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Customer"),
                                prop: "customerId"
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                staticClass: "shipper-selector",
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "10",
                                  placeholder: " ",
                                  "popper-class": "shipper-selector-popper",
                                  "method-params": { customer: true },
                                  "default-value": _vm.query.customerId || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.customerId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.CollectionSituation"),
                                prop: "clearState"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    no: "11",
                                    placeholder: " ",
                                    clearable: ""
                                  },
                                  on: { change: _vm.setQuerySelectValue },
                                  model: {
                                    value: _vm.query.clearState,
                                    callback: function($$v) {
                                      _vm.$set(_vm.query, "clearState", $$v)
                                    },
                                    expression: "query.clearState"
                                  }
                                },
                                _vm._l(_vm.cTypes, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: { label: "PO. No.", prop: "customerRefNo" }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "12" },
                                model: {
                                  value: _vm.query.customerRefNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "customerRefNo", $$v)
                                  },
                                  expression: "query.customerRefNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.SoNo"),
                                prop: "soNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "13" },
                                model: {
                                  value: _vm.query.soNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "soNo", $$v)
                                  },
                                  expression: "query.soNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: this.$t("SeaExport.PortOfDestination"),
                                prop: "destinationPortCode"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                ref: "pod",
                                attrs: {
                                  no: "14",
                                  placeholder: " ",
                                  "select-type":
                                    _vm.query.portType === "AE"
                                      ? _vm.selectTypeNames.basic_data_Airport
                                      : _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value":
                                    _vm.query.destinationPortCode,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.query.destinationPortCode =
                                      p.code)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.BusinessType"),
                                prop: "jobLobs"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "15",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_SystemConstants$LOBS,
                                  filterable: "",
                                  placeholder: " ",
                                  "callback-method-type": "value",
                                  multiple: true,
                                  "default-multiple-value": _vm.query.jobLobs
                                },
                                on: {
                                  parentCallBack: function(value) {
                                    return (_vm.query.jobLobs = [].concat(
                                      value
                                    ))
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.CustomsNo"),
                                prop: "customsNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "16" },
                                model: {
                                  value: _vm.query.customsNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "customsNo", $$v)
                                  },
                                  expression: "query.customsNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Mbl2"),
                                prop: "jobMbl"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "17" },
                                model: {
                                  value: _vm.query.jobMbl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "jobMbl", $$v)
                                  },
                                  expression: "query.jobMbl"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.ShippingCompany"),
                                prop: "jobCarrierId"
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                attrs: {
                                  no: "18",
                                  placeholder: " ",
                                  "method-params": { seaCmp: true },
                                  "default-value": _vm.query.jobCarrierId || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.jobCarrierId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Vessel"),
                                prop: "vessel"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "19",
                                  filterable: "",
                                  clearable: "",
                                  placeholder: " ",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Vessel,
                                  "tag-name": "englishName",
                                  "tag-value": "englishName",
                                  "default-value": _vm.query.vessel
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.query.vessel = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_TypeOfPort"),
                                prop: "portType"
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { no: "20" },
                                  model: {
                                    value: _vm.query.portType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.query, "portType", $$v)
                                    },
                                    expression: "query.portType"
                                  }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { float: "left" },
                                          attrs: { label: "SE" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_OceanFreight"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { float: "left" },
                                          attrs: { label: "AE" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("CargoMsg.Cargo_Air"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Status"),
                                prop: "status"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "21",
                                  filterable: "",
                                  clearable: "",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_SystemConstants$FILE_STATUS3,
                                  placeholder: " ",
                                  "default-value": _vm.query.status || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.query.status = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.OperatingCompany"),
                                prop: "companyCName"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "22" },
                                model: {
                                  value: _vm.query.companyCName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "companyCName", $$v)
                                  },
                                  expression: "query.companyCName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Sales"),
                                prop: "jobSales"
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                attrs: {
                                  no: "23",
                                  "method-params": {
                                    category: "role",
                                    shape: "sales"
                                  },
                                  "default-value": _vm.query.jobSales,
                                  placeholder: " "
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.jobSales = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.SalesDepartment"),
                                prop: "jobSalesDepartments"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "24",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_Department_All,
                                  filterable: "",
                                  placeholder: " ",
                                  "callback-method-type": "value",
                                  multiple: true,
                                  "default-multiple-value":
                                    _vm.query.jobSalesDepartments
                                },
                                on: {
                                  parentCallBack: function(value) {
                                    return (_vm.query.jobSalesDepartments = [].concat(
                                      value
                                    ))
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Voyage"),
                                prop: "voyageFlight"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "25" },
                                model: {
                                  value: _vm.query.voyageFlight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "voyageFlight", $$v)
                                  },
                                  expression: "query.voyageFlight"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "26", type: "primary" },
                      on: { click: _vm.queryHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_CRFileBack_file"
                          ]),
                          expression:
                            "$checkPermission(['button_CRFileBack_file'])"
                        }
                      ],
                      attrs: { no: "27", type: "primary" },
                      on: { click: _vm.onBack }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Back")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_CRFileBack_file"
                          ]),
                          expression:
                            "$checkPermission(['button_CRFileBack_file'])"
                        }
                      ],
                      attrs: {
                        no: "28",
                        disabled: !_vm.opButton.btReturn,
                        type: "primary"
                      },
                      on: { click: _vm.onReturn }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SendBack")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_CRFileBack_file"
                          ]),
                          expression:
                            "$checkPermission(['button_CRFileBack_file'])"
                        }
                      ],
                      attrs: {
                        no: "29",
                        disabled: !_vm.opButton.btCancelReturn,
                        type: "primary"
                      },
                      on: { click: _vm.onCancelReturn }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RevokeWithdrawal")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "30",
                        disabled: !_vm.opButton.backListBtn,
                        type: "primary"
                      },
                      on: { click: _vm.popUpBackList }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RetreatASingle")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "31",
                        disabled: !_vm.opButton.gatherBtn,
                        type: "primary"
                      },
                      on: { click: _vm.popUpInvoiceInfo }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CollectFormation")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "32", type: "primary" },
                      on: { click: _vm.onPrint }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_PrintWithdrawalList"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "33", type: "primary" },
                      on: { click: _vm.clearPage }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ResetFilter")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticStyle: { display: "flex", height: "65%" } }, [
          _c(
            "div",
            {
              staticClass: "section",
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                width: "100%"
              }
            },
            [
              _c("cargo-ag-grid", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "100%", height: "60%" },
                attrs: {
                  "config-module": "9500001",
                  "locale-text-func": _vm._i18nGridLocalText,
                  "grid-options": _vm.businessList.gridOptions,
                  "column-defs": _vm.businessList.columnDefs,
                  "row-data": _vm.businessList.rowData,
                  "grid-params": _vm.businessList.gridParams
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.businessList, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.businessList, "gridParams", $event)
                  },
                  gridReady: _vm.onGridReady
                }
              }),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module": "9500003",
                      total: _vm.businessList.total,
                      page: _vm.businessList.filter.pageNum,
                      limit: _vm.businessList.filter.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(
                          _vm.businessList.filter,
                          "pageNum",
                          $event
                        )
                      },
                      "update:limit": function($event) {
                        return _vm.$set(
                          _vm.businessList.filter,
                          "pageSize",
                          $event
                        )
                      },
                      pagination: _vm.toQueryByPage
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "section" }, [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticStyle: { "padding-top": "5px" },
                  attrs: {
                    inline: true,
                    "label-width": "85px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("SeaExport.Customer") }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "34",
                          readonly: true,
                          "custom-style": "width:160px",
                          disabled: true,
                          placeholder: " ",
                          "popper-class": "shipper-selector-popper",
                          "method-params": { customer: true },
                          "default-value":
                            _vm.businessList.selectedData.customerId || ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: this.$t("CargoMsg.Cargo_CustomerAddress")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          no: "35",
                          title: _vm.businessList.selectedData.expressAddress,
                          readonly: true,
                          disabled: true
                        },
                        model: {
                          value: _vm.businessList.selectedData.expressAddress,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "expressAddress",
                              $$v
                            )
                          },
                          expression: "businessList.selectedData.expressAddress"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("SeaExport.BookingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          no: "36",
                          readonly: true,
                          disabled: true,
                          placeholder: " ",
                          "tag-name": "shortName",
                          "method-params": { bookingAgent: true },
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "default-value":
                            _vm.businessList.selectedData.bookingAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.businessList.selectedData.bookingAgent =
                              p.cmpIdx)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "padding-top": "5px" },
                  attrs: {
                    inline: true,
                    "label-width": "85px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: this.$t("CargoMsg.Cargo_VesselAndVoyage")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          no: "37",
                          value: _vm.getVesselAndVoyage(),
                          readonly: true,
                          disabled: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("CargoMsg.Cargo_SailingDay") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          no: "38",
                          readonly: true,
                          disabled: true,
                          type: "date",
                          clearable: "",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.businessList.selectedData.etd,
                          callback: function($$v) {
                            _vm.$set(_vm.businessList.selectedData, "etd", $$v)
                          },
                          expression: "businessList.selectedData.etd"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("SeaExport.CustomsBroker") }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "39",
                          disabled: true,
                          placeholder: " ",
                          "method-params": {
                            customsBroker: true,
                            seaExport: true,
                            active: true
                          },
                          "default-value":
                            _vm.businessList.selectedData.customsBroker || "",
                          "custom-style": "width:160px;"
                        },
                        on: {
                          change: function(p) {
                            _vm.businessList.selectedData.customsBroker =
                              p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "padding-top": "5px" },
                  attrs: {
                    inline: true,
                    "label-width": "85px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("CargoMsg.Cargo_RefNbr") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          no: "40",
                          value:
                            _vm.businessList.selectedData.lob !== "SE"
                              ? _vm.businessList.selectedData.mbl
                              : _vm.businessList.selectedData.soNo,
                          readonly: true,
                          disabled: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("CargoMsg.Cargo_CustomsNo") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "41", readonly: true, disabled: true },
                        model: {
                          value: _vm.businessList.selectedData.customsNo,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "customsNo",
                              $$v
                            )
                          },
                          expression: "businessList.selectedData.customsNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("SeaExport.Operation") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          no: "42",
                          readonly: true,
                          disabled: true,
                          filterable: "",
                          placeholder: " ",
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "callback-method-type": "value",
                          "default-value":
                            _vm.businessList.selectedData.op === 0
                              ? ""
                              : _vm.businessList.selectedData.op,
                          "callback-params": { key: "op" }
                        },
                        on: { parentCallBack: _vm.setQuerySelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("SeaExport.Sales") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          no: "43",
                          readonly: true,
                          disabled: true,
                          filterable: "",
                          placeholder: " ",
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "callback-method-type": "value",
                          "default-value":
                            _vm.businessList.selectedData.salesId === 0
                              ? ""
                              : _vm.businessList.selectedData.salesId,
                          "callback-params": { key: "sales" }
                        },
                        on: { parentCallBack: _vm.setQuerySelectValue }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "85px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Remarks") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "1000px" },
                        attrs: {
                          no: "44",
                          type: "textarea",
                          rows: 3,
                          readonly: true,
                          disabled: true
                        },
                        model: {
                          value: _vm.businessList.selectedData.remark,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "remark",
                              $$v
                            )
                          },
                          expression: "businessList.selectedData.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "padding-top": "5px" },
                  attrs: {
                    inline: true,
                    "label-width": "85px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: this.$t(
                          "CargoMsg.Cargo_RecipientSCompanyOfWithdrawal"
                        )
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "45", readonly: true, disabled: true },
                        model: {
                          value: _vm.businessList.selectedData.receiveCompany,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "receiveCompany",
                              $$v
                            )
                          },
                          expression: "businessList.selectedData.receiveCompany"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: this.$t("CargoMsg.Cargo_RecipientOfWithdrawal")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "46", readonly: true, disabled: true },
                        model: {
                          value: _vm.businessList.selectedData.receivePerson,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "receivePerson",
                              $$v
                            )
                          },
                          expression: "businessList.selectedData.receivePerson"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: this.$t("CargoMsg.Cargo_Tel") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "47", readonly: true, disabled: true },
                        model: {
                          value: _vm.businessList.selectedData.receiveTel,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "receiveTel",
                              $$v
                            )
                          },
                          expression: "businessList.selectedData.receiveTel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: this.$t(
                          "CargoMsg.Cargo_ReturnOrderExpressNumber"
                        )
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "48", readonly: true, disabled: true },
                        model: {
                          value: _vm.businessList.selectedData.returnExpressNo,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "returnExpressNo",
                              $$v
                            )
                          },
                          expression:
                            "businessList.selectedData.returnExpressNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "85px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_WithdrawalAddress")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "1000px" },
                        attrs: {
                          no: "49",
                          type: "textarea",
                          rows: 3,
                          readonly: true,
                          disabled: true
                        },
                        model: {
                          value: _vm.businessList.selectedData.expressAddress,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.businessList.selectedData,
                              "expressAddress",
                              $$v
                            )
                          },
                          expression: "businessList.selectedData.expressAddress"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("dc-send-out-window", {
        ref: "dcSendOut",
        attrs: {
          "send-out-dialog": _vm.sendOutDialog,
          visible: _vm.sendOutDialog.visible,
          job: _vm.job,
          "selected-files": _vm.selectedFiles
        },
        on: { successHandler: _vm.successHandler }
      }),
      _c("file-dialog", {
        ref: "fileDialog",
        attrs: {
          visible: _vm.editDialog.visible,
          "is-remark-only": _vm.editDialog.isRemarkOnly,
          "selected-file": _vm.businessList.selectedData,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          successHandler: _vm.successHandler
        }
      }),
      _c("dc-take-back-window", {
        ref: "dcTakeBack",
        attrs: {
          "take-back-dialog": _vm.takeBackDialog,
          visible: _vm.takeBackDialog.visible,
          job: _vm.job,
          "selected-files": _vm.takeBackDialog.selectedFiles
        },
        on: { successHandler: _vm.backSuccessHandler }
      }),
      _c("dc-return-window", {
        ref: "dcReturn",
        attrs: {
          "return-dialog": _vm.returnDialog,
          visible: _vm.returnDialog.visible,
          "selected-files": _vm.selectedFiles
        },
        on: { successHandler: _vm.backSuccessHandler }
      }),
      _c("back-list-window", {
        ref: "dcReturn",
        attrs: {
          "row-list": _vm.backList.rowList,
          visible: _vm.backList.visible
        },
        on: { visibleHandler: _vm.visibleHandler }
      }),
      _c("collect-info-window", {
        ref: "dcReturn",
        attrs: {
          "row-list": _vm.collectInfo.rowList,
          visible: _vm.collectInfo.visible
        },
        on: { visibleHandler: _vm.visibleHandler }
      }),
      _c("cargo-custom-info-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.job,
          title: _vm.cloudFile.title,
          "custom-info": _vm.cloudFile.customInfo,
          "document-type": _vm.cloudFile.documentType,
          lob: _vm.job.lob,
          "op-button": false,
          "show-all": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }